// tslint:disable: no-submodule-imports
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, } from '@apollo/client';
import { onError } from '@apollo/client/link/error';
import { openSnackbar } from './components/common/snackbar-portal';
import { ErrorMessage } from './errors';
import { loader } from 'graphql.macro';
// Local state type defs (schema)
var typeDefs = loader('./apollo-schema.graphql');
// Initial local state
var cache = new InMemoryCache({
    typePolicies: {
        Query: {
            fields: {
                snackbarIsOpen: {
                    read: function (value) {
                        if (value === void 0) { value = false; }
                        return value;
                    },
                },
                snackbarText: {
                    read: function (value) {
                        if (value === void 0) { value = ''; }
                        return value;
                    },
                },
            },
        },
    },
});
var httpLink = new HttpLink({
    // uri: 'http://localhost:4000/',
    uri: '/graphql',
    credentials: 'same-origin',
});
var errorLink = onError(function (_a) {
    var graphQLErrors = _a.graphQLErrors, networkError = _a.networkError;
    if (graphQLErrors) {
        graphQLErrors.forEach(function (error) {
            var message = error.message;
            if (message in ErrorMessage) {
                openSnackbar(ErrorMessage[message]);
            }
            else {
                // TODO: Make all error checks to server - No GraphQL errors should be
                // unknown here.
                // tslint:disable-next-line no-console
                console.error(error);
                openSnackbar(ErrorMessage.unknownError);
            }
        });
    }
    if (networkError) {
        openSnackbar(ErrorMessage.networkError);
    }
});
// Apollo GraphQL client
// https://www.apollographql.com/docs/react/basics/setup.html#creating-client
// https://www.apollographql.com/docs/react/advanced/boost-migration/
export var apolloClient = new ApolloClient({
    cache: cache,
    link: ApolloLink.from([errorLink, httpLink]),
    // https://www.apollographql.com/docs/react/essentials/local-state/#client-side-schema
    typeDefs: typeDefs,
    // https://www.apollographql.com/docs/react/api/core/ApolloClient/#example-defaultoptions-object
    defaultOptions: {
        watchQuery: {
            pollInterval: 5000,
        },
    },
});
//# sourceMappingURL=apollo.js.map